import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody50';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy50 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Preliminary Due Diligence & Deal Model</h2>";

  return (
    <>
        <Helmet>
        <title>Preliminary Due Diligence & Deal Model</title>
        <meta property="og:title" content="Preliminary Due Diligence & Deal Model" />
        <meta property='og:description' content='Preliminary Due Diligence & Deal Model'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy50" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy50
